import router from '@/router';
import store from '@/store/store';
import {
  clDntActFileED,
  getFile,
  fileComments,
  sendComment,
  fileBinnacle,
  createDnt,
  updateDnt,
  cancelFile,
  downloadAttachments,
  attachmentsFiles,
  clAsignFile,
  sendFile,
  fileTimeline,
  clReturnFileED,
  // eslint-disable-next-line import/named
  activitiesFile,
  addActivity,
  updateActivity,
  clDntArchiveFileED, clReturnFileEDAguasAndinas,
  clUpdateMetadata, ioExpedientesActualizar
} from '@/febos/servicios/api/dnt.api';
import { sendTicket } from '@/febos/servicios/api/tickets.api';
import { sendToFlowFile } from '@/febos/servicios/api/aprobaciones.api';
import {
  idVersionOpenText,
  ioDownloadPrivateFile, linkOpenText,
  oiDivisionPolitica,
  openText
} from '@/febos/servicios/api/herramientas.api';
import { clGetReferences } from '@/febos/servicios/api/documents.api';
import { getSearchParams } from '@/febos/global/utils/router';
import { types } from '@/febos/chile/dnt/config/wizard';
import { ioExpedientesSearch } from '@/febos/servicios/api/busqueda.api';

export const listDocuments = async ({ commit }, data) => {
  try {
    commit('SET_DNT_LIST', {});
    commit('SET_LOADING', true);
    const response = await ioExpedientesSearch(data);
    commit('SET_DNT_LIST', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const detailDnt = async ({ commit }, payload) => {
  try {
    commit('SET_DETAIL_DNT', {});
    commit('SET_LOADING', true);
    const response = await getFile(payload);
    commit('SET_DETAIL_DNT', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getAttachmentsDnt = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await attachmentsFiles(payload);
    commit('SET_ATTACHMENTS_DNT', response.data.adjuntos);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const downloadFilePDF = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await getFile(payload);
    window.open(response.data.imagenLink, '_blank');
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const downloadPrivateFile = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await ioDownloadPrivateFile(payload);
    window.open(response.data.url, '_blank');
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const downloadAttachmentFiles = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await downloadAttachments(payload);
    window.open(response.data.rutaArchivosComprimidos, '_blank');
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const attemptCancelFile = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await cancelFile(payload);
    await commit('UPDATE_CANCELED_DNT', payload);
    store.commit('Modals/CLOSE_MODAL');
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const clearErrorMessage = ({ commit }) => {
  commit('SET_ERROR_MESSAGE', '');
};

export const processDntFileED = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await clDntActFileED(payload);
    await commit('UPDATE_PROCESSED_DNT', payload);
    store.commit('Modals/CLOSE_MODAL');
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};
export const deleteDraftDntFileED = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await clDntArchiveFileED(payload);
    await commit('UPDATE_DELETED_DRAFT_DNT', payload);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const updateSentMetadataStatus = async ({ commit }, { febosId, metadata }) => {
  try {
    commit('SET_LOADING', true);
    const response = await clUpdateMetadata(febosId, metadata);
    await commit('UPDATE_FILE', { febosId, metadata });
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const controlDntFileED = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await clDntActFileED(payload);
    await commit('UPDATE_CONTROLLED_DNT', payload);
    store.commit('Modals/CLOSE_MODAL');
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const archiveDntFileED = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await clDntArchiveFileED(payload);
    await commit('UPDATE_ARCHIVED_DNT', payload);
    store.commit('Modals/CLOSE_MODAL');
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const asignDntFileED = async ({ commit }, {
  febosId,
  view
}) => {
  try {
    commit('SET_LOADING', true);
    const response = await clAsignFile(febosId, view);
    commit('SET_SUCCESS_MESSAGE', response.data);
    commit('UPDATE_ASIGNED_FILE', febosId);
    store.commit('Modals/CLOSE_MODAL');
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const closeModal = ({ commit }, payload) => {
  commit('CLOSE_MODAL', payload);
};

export const getFileDnt = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    commit('SET_DETAIL_FILE', {});
    commit('SET_ATTACHMENTS_DNT', []);
    const response = await getFile(payload);
    commit('SET_DETAIL_FILE', response.data);
    commit('SET_ATTACHMENTS_DNT', response.data.adjuntos);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export async function setWizardStorageFile({ commit }, file) {
  try {
    commit('SET_LOADING', true);
    commit('SET_WIZARD_STORAGE', file);
  } finally {
    commit('SET_LOADING', false);
  }
}

export const prepareWizardDataStorage = async ({ commit, getters }, { mapper }) => {
  try {
    commit('SET_LOADING', true);
    const dataStorage = getters.wizardStorage;
    commit('CLEAR_WIZARD_DATA');
    commit(
      'SET_WIZARD_DATA',
      mapper ? mapper(dataStorage) : dataStorage
    );
  } finally {
    commit('SET_LOADING', false);
  }
};

export const loadWizardData = async ({ commit }, { id, mapper, loadAllData }) => {
  try {
    commit('SET_LOADING', true);
    const payload = loadAllData
      ? {
        destinatarios: 'si',
        referencias: 'si',
        etiquetas: 'si',
        retornarDnt: 'si',
        metadata: 'si'
      }
      : {
        imagen: 'si',
        regenerar: 'no',
        tipoImagen: 0,
        destinatarios: 'si',
        retornarDnt: 'si',
        metadata: 'si',
        adjuntos: 'si'
      };

    const { data } = await getFile({
      febosId: id,
      ...payload
    });

    if (loadAllData) {
      const { data: { adjuntos } } = await attachmentsFiles(
        { febosId: id }
      );
      data.adjuntos = adjuntos;
    }

    commit('CLEAR_WIZARD_DATA');
    commit(
      'SET_WIZARD_DATA',
      mapper ? mapper(data) : data
    );
  } finally {
    commit('SET_LOADING', false);
  }
};

export const loadFileData = async ({ commit }, { id, mapper }) => {
  try {
    // commit('SET_LOADING', true);

    const payload = {
      destinatarios: 'si',
      referencias: 'si',
      etiquetas: 'si',
      retornarDnt: 'si',
      metadata: 'si'
    };

    const { data } = await getFile({
      febosId: id,
      ...payload
    });
    const { data: { adjuntos } } = await attachmentsFiles(
      { febosId: id }
    );
    data.adjuntos = adjuntos;
    commit('CLEAR_WIZARD_DATA');
    commit(
      'SET_WIZARD_DATA',
      mapper ? mapper(data) : data
    );
  } finally {
    commit('SET_LOADING', false);
  }
};

export const clearWizardData = ({ commit }) => {
  commit('CLEAR_WIZARD_DATA');
};

export const addWizardData = ({ commit }, payload) => {
  commit('ADD_WIZARD_DATA', payload);
};

export const mergeWizardData = ({ commit }, payload) => {
  commit('MERGE_WIZARD_DATA', payload);
};

export const getFileComments = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    commit('SET_COMMENTS', []);
    const response = await fileComments(payload);
    commit('SET_COMMENTS', response.data.comentarios);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getFileBinnacle = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING_BINNACLE', true);
    commit('SET_BINNACLE', {});
    const response = await fileBinnacle(payload);
    commit('SET_BINNACLE', response.data.bitacora);
    return response.data;
  } finally {
    commit('SET_LOADING_BINNACLE', false);
  }
};

export const sendDntComment = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await sendComment(payload);
    commit('ADD_COMMENT', response.data.comentario);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const sendDntFile = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await sendFile(payload);
    commit('SET_SUCCESS_MESSAGE', response.data);
    commit('UPDATE_SENT_FILE', payload.febosId);
    store.commit('Modals/CLOSE_MODAL');
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const sendTicketHelp = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await sendTicket(payload);
    commit('SET_SUCCESS_MESSAGE', 'Ticket de ayuda enviado, te contactaremos!');
    store.commit('Modals/CLOSE_MODAL');
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const saveDocument = async ({ commit }, {
  id, data, isDraft, redirectFlow
// eslint-disable-next-line consistent-return
}) => {
  commit('SET_LOADING', true);
  try {
    const response = !id
      ? await createDnt(data)
      : await updateDnt(id, data);

    if (isDraft && id) {
      return response;
    }

    if (isDraft) {
      await router.push({
        name: 'files-wizard-update',
        params: {
          wizard: types[response.data.dnt.claseMercadoPublico],
          id: response.data.dnt.febosId
        },
        query: getSearchParams()
      });
      return response;
    }

    if (redirectFlow) {
      await router.push({
        name: 'files-wizard-update',
        params: { wizard: 'flujo', id: response.data.dnt.febosId }
      });
      return response;
    }
    await router.push({ name: 'files', params: { view: 'general' } });
    return response;
  } catch (e) {
    console.log('E', e);
    commit('SET_ERROR_MESSAGE', e.context);
  } finally {
    commit('SET_LOADING', false);
  }
};

export const saveDocumentSiss = async ({ commit }, {
  id, data, fromCompleteFile, entryExternalFile
  // eslint-disable-next-line consistent-return
}) => {
  commit('SET_LOADING', true);
  try {
    const response = !id
      ? await createDnt(data)
      : await updateDnt(id, data);

    if (fromCompleteFile) {
      await router.push({ name: 'files', params: { view: 'completitudDatos' } });
      return response;
    }

    if (entryExternalFile) {
      await router.go();
      return response;
    }
    await router.push({ name: 'files', params: { view: 'general' } });
    return response;
  } catch (e) {
    console.log('E', e);
    commit('SET_ERROR_MESSAGE', e.context);
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getFileTimeline = async ({ commit }, febosId) => {
  try {
    commit('SET_LOADING', true);
    commit('SET_TIMELINE', {});
    const response = await fileTimeline(febosId);
    commit('SET_TIMELINE', response.data.destinatarios);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const returnFileEd = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await clReturnFileED(payload);
    await commit('UPDATE_SENT_FILE', payload.febosId);
    store.commit('Modals/CLOSE_MODAL');
    commit('SET_SUCCESS_MESSAGE', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const sendToFlow = async ({ commit }, { data }) => {
  commit('SET_LOADING', true);
  try {
    commit('SET_LOADING', true);
    const payload = {
      params: {
        aprobacionId: 0,
        temporal: true,
        privado: data.ejecucion.privado
      },
      body: data
    };
    const response = await sendToFlowFile(payload);
    await router.push({
      name: 'start'
    });
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getActivitiesFile = async ({ commit }, { payload, historico }) => {
  try {
    commit('SET_ACTIVITIES_TIMELINE_FILE', []);
    commit('SET_LOADING', true);
    const response = await activitiesFile(payload);
    if (historico) {
      commit('SET_ACTIVITIES_TIMELINE_FILE', response.data.actividades);
    } else {
      commit('SET_ACTIVITIES_FILE', response.data.actividades);
    }
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const addActivityFile = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await addActivity(payload);
    store.commit('Modals/CLOSE_MODAL');
    commit('SET_SUCCESS_MESSAGE', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const updateActivityFile = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await updateActivity(payload);
    store.commit('Modals/CLOSE_MODAL');
    commit('SET_SUCCESS_MESSAGE', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const answerCreateFile = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await createDnt(payload);
    commit('SET_SUCCESS_MESSAGE', response.data);
    const path = `/documentos/${payload.dnt.claseMercadoPublico}/${response.data.dnt.febosId}`;
    store.commit('Modals/CLOSE_MODAL');
    await router.push({ path });
  } catch (e) {
    commit('SET_ERROR_MESSAGE', e.context);
  } finally {
    commit('SET_LOADING', false);
  }
};

export const searchReferences = async ({ commit }, febosId) => {
  try {
    commit('CLEAR_REFERENCES');
    commit('SET_LOADING', true);
    const response = await clGetReferences(febosId);
    commit('SET_REFERENCES_DNT', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const selectFileState = ({ commit }, file) => {
  commit('SET_SELECTED_FILE', file);
};

export const getCommunes = async ({ commit }, payload) => {
  const response = await oiDivisionPolitica(payload);
  commit('SET_COMMUNES', response.data.divisiones);
};

export const createConventionDnt = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await createDnt(payload);
    return response.data.dnt;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const editConventionDnt = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await updateDnt(payload.dnt.febosId, payload);
    return response.data.dnt;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const loadOpenText = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await openText(payload);
    const data = response.data;
    // Retornar form + metadata de paginación y source
    return {
      ...data.form,
      pagination: data.pagination || null,
      source: data.source || null
    };
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getIdVersionOpenText = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await idVersionOpenText(payload);
    return response.data.versions.data.list;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const getLinkOpenText = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await linkOpenText(payload);
    return response.data.document;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const returnFileEdAguasAndinas = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    const response = await clReturnFileEDAguasAndinas(payload);
    await commit('UPDATE_SENT_FILE', payload.febosId);
    store.commit('Modals/CLOSE_MODAL');
    commit('SET_SUCCESS_MESSAGE', response.data);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const docDigitalDntFileED = async ({ commit }, payload) => {
  try {
    commit('SET_LOADING', true);
    console.log(payload);
    // const response = await clDntActFileED(payload);
    // await commit('UPDATE_CONTROLLED_DNT', payload);
    // store.commit('Modals/CLOSE_MODAL');
    // return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const setDocumentInfo = async ({ commit }, document) => {
  commit('FORM_SELECTED_DOCUMENT', document);
};

export const saveDocumentsList = ({ commit }, options) => {
  commit('DOCUMENTS_OPTIONS', options);
};

export const actualizarCampos = async ({ commit }, { id, payload }) => {
  try {
    commit('SET_LOADING', true);
    const response = await ioExpedientesActualizar(id, payload);
    return response.data;
  } finally {
    commit('SET_LOADING', false);
  }
};

export const navigateToForm = async ({ commit }, { data }) => {
  console.log('🟢 navigateToForm action called with data:', data);

  const documentType = data.dnt && data.dnt.documentType ? data.dnt.documentType : data.documentType;
  const locationType = data.dnt && data.dnt.locationType ? data.dnt.locationType : data.locationType || 'root';
  const locationId = data.dnt && data.dnt.locationId ? data.dnt.locationId : data.locationId || '';

  console.log('🟢 Navigating to form with:', { documentType, locationType, locationId });

  await router.push({
    name: 'edit-custom-document',
    params: { type: documentType },
    query: {
      locationType: locationType,
      locationId: locationId
    }
  });
};
